import { gql } from '@apollo/client'

export const GIFT_CARD_STATUS = gql`
    query GiftCardStatus($GiftCardStatusInput: GiftCardStatusInput!) {
        GiftCardStatus(giftCard: $GiftCardStatusInput) {
            success
            message
            cardData {
                name
                is_payment_active
                is_pin_required
                is_expired
            }
        }
    }
`

export type GiftCardStatusQueryVariables = {
    GiftCardStatusInput: {
        cardNumber: string
    }
}

export type GiftCardStatusQuery = {
    GiftCardStatus: {
        success: boolean
        message: string
        cardData: {
            name: string
            is_payment_active: boolean
            is_pin_required: boolean
            is_expired: boolean
        } | null
    }
}
